export const TYPE_OF_COLUMN = { LEFT: "left", RIGHT: "right" };

export const RELACIONAR_COLUMNAS_SOUNDS = {
  ACTIVO: "relacionar-columnas-active",
  CORRECTO: "relacionar-columnas-correct",
  ENCIMA: "relacionar-columnas-hover",
  MOVIENDO: "relacionar-columnas-move",
};

export const SLOW_SCROLL_AMOUNT = 15;
export const FAST_SCROLL_AMOUNT = 30;
export const LINE_THICKNESS = 5;
export const CIRCLE_RADIUS = 8;

export const ZONE_NAMES = {
  TOP: "way-up",
  UP: "up",
  CENTER: null,
  DOWN: "down",
  BOTTOM: "way-down",
};

export const ZONE_SPEEDS = {
  [ZONE_NAMES.TOP]: -FAST_SCROLL_AMOUNT,
  [ZONE_NAMES.BOTTOM]: FAST_SCROLL_AMOUNT,
  [ZONE_NAMES.UP]: -SLOW_SCROLL_AMOUNT,
  [ZONE_NAMES.DOWN]: SLOW_SCROLL_AMOUNT,
};

export const FAST_THRESHOLD = 70;
export const SLOW_THRESHOLD = 140;

export const CARD_TYPES = {
  IMAGE: "ImageData",
  TEXT_AUDIO: "TextAudioData",
  AUDIO: "AudioData",
  TEXT_IMAGE: "TextImageData",
  TEXT: "TextData",
};
